import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import CardSimple from 'screens/components/basic/CardSimple';
import Body from './Body';
import Header from './Header';
import { getSellThroughReport, getCsvReport } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import Pagination from 'screens/components/basic/Pagination';
import reportsUtil from 'utils/reportsApi';
import Grid from 'screens/components/basic/Grid';
import { reportSellThroughReport } from 'utils/breadcrumbInfo';
import KnowledgeBase from 'screens/components/basic/KnowledgeBaseIcon';
import PageHeader from 'screens/components/basic/PageHeader';
import { showError } from 'actions/CommonActions';
import { checkDateRange } from 'utils/helpers';
import WithRouter from 'custom/withRouter';
import DateCurrentDisplay from 'screens/containers/report/DateCurrentDisplay';

class SellThroughReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            showBody: false,
            totalRow: 0,
            model: {
                beginDate: 0,
                endDate: 0,
                branch: 0
            }
        };

        this.showBody = this.showBody.bind(this)
    }

    componentWillMount() {
        const date = new Date();
        this.props.formInput(new Date(date.getFullYear(), date.getMonth() - 1, 1), `SellThroughReportBeginDate`);
        this.props.formInput(date, `SellThroughReportEndDate`);
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    showBody() {
        if (checkDateRange(this.props.beginDate, this.props.endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.filter();
            this.setState({ showBody: true });
        }
    }

    getReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branch = this.props.branch || this.props.loggedBranch;
        let pageNumber = this.state.activePage;
        let pageSize = this.state.itemsPerPage;

        this.props.getSellThroughReport({ beginDate, endDate, pageNumber, pageSize, branch });
    }

    downloadReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branch = this.props.branch || this.props.loggedBranch;
        let pageNumber = 1;
        let pageSize = 999999;
        if (checkDateRange(beginDate, endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.props.getCsvReport(`reports/excel/sellthrough?beginDate=${beginDate}&endDate=${endDate}&branch=${branch}&pageNumber=${pageNumber}&pageSize=${pageSize}`, "sellthrough");
        }
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }
    componentWillReceiveProps = (newProps) => {
        if (this.state.showBody) {
            const totalRow = newProps.sellThrough && newProps.sellThrough.length > 0 ? newProps.sellThrough[0].totalRows : 0;
            this.setState({ totalRow: totalRow });
        }
    }

    render() {
        return (
            <Grid headerContent={reportSellThroughReport}>
                <PageHeader 
                    title={LOOKUP.report.sellThrough.text}
                    icon={<KnowledgeBase link="https://knowledge.techpos.ca/en/knowledge/what-is-the-sell-through-report" />}
                    description={LOOKUP.report.sellThrough.description}
                />
                <Header loggedBranch={this.props.loggedBranch} branchOptions={this.props.brachOptions} filter={this.filter} download={this.downloadReport} showBody={this.showBody} />
                {
                    this.state.showBody &&
                    <DateCurrentDisplay />
                }
                {
                    this.state.showBody &&
                    <CardSimple>
                        <Body sellThrough={this.props.sellThrough} beginDate={this.props.beginDate} endDate={this.props.endDate} />
                        <Pagination
                            length={this.state.totalRow}
                            itemsPerPage={this.state.itemsPerPage}
                            activePage={this.state.activePage}
                            onPageChange={this.changePage}
                        />
                    </CardSimple>
                }
            </Grid>
        );
    }
}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })
    return {
        brachOptions: brachOptions,
        sellThrough: state.reports.sellThrough,
        loggedBranch: state.common.branchId,
        beginDate: state.form.SellThroughReportBeginDate,
        endDate: state.form.SellThroughReportEndDate,
        branch: state.form.SellThroughReportBranchOption
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getSellThroughReport: model => dispatch(getSellThroughReport(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        showError: (message) => dispatch(showError(message)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(SellThroughReport));